export {
  PRIMARY_CONTROLS_STRIP_BACK_HIDDEN,
  PrimaryControlsStripBackContext,
  createPrimaryControlsStripBackRegistry,
  isPrimaryControlsStripBackOverrideEntry,
  type PrimaryControlsStripBackAppShellPlacement,
  type PrimaryControlsStripBackRegistry,
  type PrimaryControlsStripBackRegistryEntry,
  type PrimaryControlsStripBackRegistryLabelEntry,
  type PrimaryControlsStripBackRegistryOverrideEntry,
} from "#primary-controls-strip-back-context";
export { PrimaryControlsStripBackProvider } from "#primary-controls-strip-back-provider";
